import { useContext } from 'react';
import ApiKeyModalFormContext from './ApiKeyModalFormContext';

export default function useApiKeyModalFormContext() {
  const context = useContext(ApiKeyModalFormContext);
  if (!context) {
    throw new Error(
      'ApiKeyModalFormContext must be wrapped by ApiKeyModalFormContext.Provider',
    );
  }
  return context;
}
